import { graphql } from 'src/graphql';

import { TeamFields } from './teamFields.fragment';

export const UserFields = graphql(
  `
    fragment UserFields on User @_unmask {
      _id
      email
      picture
      created
      researcher {
        ux_length
        certification {
          status
        }
        onboarding {
          linkedIn
          ux_length
          methods
        }
      }
      _default_team
      contact {
        phone {
          country_code
          mobile
        }
      }
      location {
        name
        postal_code
        city
        state
        country
        latitude
        longitude
        region
      }
      meta {
        identity {
          firstname
          lastname
          middlename
          gender
        }
        social {
          linkedin {
            profile_url
          }
          google {
            id
          }
        }
        work {
          title
          company_name
        }
      }
      settings {
        notification {
          messages {
            email
            sms
            push
          }
          reminders {
            email
            sms
            push
          }
          promotional {
            email
            sms
            push
          }
        }
        tutorial {
          app
        }
        billing {
          registration
        }
        language
      }
      email_verified
      roles
      type {
        client
        researcher
      }
      Teams {
        ...TeamFields
      }
      ConnectedTeam {
        ...TeamFields
      }
    }
  `,
  [TeamFields],
);
